export interface GlobalAlertConfig {
  removeLastIfViewportOverflow?: boolean;
  customContainerClasses?: string;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
